import { useLayoutEffect, useEffect } from 'react';

/**
 * This is required since useLayoutEffect does
 * nothing in context of SSR. If you use useLayoutEffect
 * React complains about it:
 *
 * "Warning: useLayoutEffect does nothing on the server, because its effect
 * cannot be encoded into the server renderer's output format. This will lead
 * to a mismatch between the initial, non-hydrated UI and the intended UI. To
 * avoid this, useLayoutEffect should only be used in components that render
 * exclusively on the client"
 *
 * We do need useLayoutEffect though since we want to set the theme (dark or
 * light mode) BEFORE the browser enters the paint phase. Otherwise we have
 * a very ugly flashing of white before the component switches to dark mode -
 * if the user has dark mode enabled.
 */
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
